import './ReferralQuestion.scss'

import React, {Component} from 'react'
import {
  AGENT_STATUS_CLOSED,
  AGENT_STATUS_CONTRACT,
  ANSWER_TYPE, QUALIA_QUESTIONS, QUESTION_TYPE,
} from 'common/constants'
import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"
import {
  setNewTitleCompany,
  useNewSettlementSelection,
  usePriorSettlementSelection
} from 'manager/redux/referral_status'
import TitleProviderAutocomplete from "manager/views/components/ReferralStatus/Common/TitleProviderAutocomplete"
import {
  selectReferralQualiaEnabled,
  selectSelectedSettlementProvider,
} from "manager/selectors/referral_selectors"
import {updateAgentTitleQuestions} from "manager/redux/referral"
import {
  selectClosePropertyAddress,
  selectContractPropertyAddr,
  selectSelectedTitleCompany
} from "manager/selectors/referral_status_selectors"

class ReferralQuestionTitleWhoIsProvider extends Component {
  state = {
    question: null,
    isRequired: null,
  }

  async componentDidMount() {

    const {
      isReferralQualiaEnabled,
      selectSelectedSettlementProvider,
      usePriorSettlementSelection,
      editStatus,
      updateAgentTitleQuestions,
      local_selection_who_is_provider,
    } = this.props

    if (local_selection_who_is_provider) {
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: local_selection_who_is_provider})
    } else if (isReferralQualiaEnabled && selectSelectedSettlementProvider) {
      await usePriorSettlementSelection()

      const {selectedTitleCompany} = this.props
      updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: {[ANSWER_TYPE.TITLE_SELECTION]: selectedTitleCompany}})
    }

    const question = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]['question']
    const isRequired = QUALIA_QUESTIONS[editStatus][QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]['is-required']
    this.setState({question, isRequired})
  }

  onTitleProviderChange = (selectedCompanyName) => {
    const {updateAgentTitleQuestions, setLocalSelectionWhoIsProvider}= this.props
    let answer = null
    if (selectedCompanyName && selectedCompanyName.name.trim()){
      answer = {[ANSWER_TYPE.TITLE_SELECTION]: {'id': selectedCompanyName.id,'name': selectedCompanyName.name}}
    }
    updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: answer})
    setLocalSelectionWhoIsProvider(answer)
  }

  getOriginAddrOverride = () => {
    const { editStatus, contractPropertyAddr, closePropertyAddress } = this.props
    if (editStatus === AGENT_STATUS_CONTRACT) {
      return contractPropertyAddr
    }
    if (editStatus === AGENT_STATUS_CLOSED) {
      return closePropertyAddress
    }
    return null
  }

  render() {
    const {question, isRequired} = this.state
    return (
      <div className={question ? "ReferralQuestion" : null }>
        {question && <div className="question">{question}</div>}
        <div style={{marginLeft: "1%", marginRight: "1%"}}>
          <TitleProviderAutocomplete
            onTitleProviderChange={this.onTitleProviderChange}
            isRequired={isRequired}
            getOriginAddrOverride={this.getOriginAddrOverride}
          />
        </div>
      </div>
    )
  }

}


const selector = createStructuredSelector({
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
  selectSelectedSettlementProvider: selectSelectedSettlementProvider,
  selectedTitleCompany: selectSelectedTitleCompany,
  contractPropertyAddr: selectContractPropertyAddr,
  closePropertyAddress: selectClosePropertyAddress,
})

const actions = {
  usePriorSettlementSelection,
  updateAgentTitleQuestions,
  useNewSettlementSelection,
  setNewTitleCompany,
}

export default connect(selector, actions)(ReferralQuestionTitleWhoIsProvider)

